




























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Section } from "@/common/interface";
import store from "@/store";
import { Getter, Action } from "vuex-class";
import DashLine from "@/components/common/edit/DashLine.vue";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import ActivitySwitch from "@/components/common/edit/ActivitySwitch.vue";
import distributeRewardExplanation from "./DistributeRewardExplanation.vue";
import getUrlParam from "@/common/utils/getUrlParam";
import { resolveBoundaryValue } from '@/common/utils/format';

@Component({
  components: {
    "activity-label": ActivityLabel,
    "dash-line": DashLine,
    "activity-switch": ActivitySwitch,
    "distribute-reward-explanation": distributeRewardExplanation,
  },
})
export default class ActivityRewardSetting extends Vue {
  @Action("changeDistributeParameter") changeDistributeParameter!: Function;
  @Action("changeShowFooter") changeShowFooter!: Function;

  type: string = getUrlParam("type") as string;
  pageType: string = getUrlParam("type") as string;
  @Getter("distributeTypeParameter") distributeTypeParameter!: any;
  @Getter("xcxFlag") xcxFlag!: boolean;

  get sectionConf() {
    return store.getters.section;
  }

  get disabled() {
    return getUrlParam("type") === "reEdit";
  }

  openDistributorRewardModal() {
    this.changeDistributeParameter({ openDistributeRewardModal: true });
    this.changeShowFooter();
  }

  handleToggleSecondDistribute(status: boolean) {
    if (this.pageType === "edit") {
      this.changeDistributeParameter({ hasOpenSecondDistribute: status, secondReward:"" });
    }
  }

  handleInputBlur(value: number, type: string, hasDecimal: boolean = false) {
    const _value = resolveBoundaryValue(value, hasDecimal);
    this.changeDistributeParameter({ [type]: _value });
  }
}
